import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Users } from 'lucide-react';

export const TalentPageSkeleton: React.FC = () => (
  <div className="min-h-screen bg-background p-4">
    <div className="max-w-4xl mx-auto">
      <Card className="border border-border shadow-lg">
        <CardHeader className="text-center pb-6">
          <div className="flex items-center justify-center gap-3 mb-2">
            <Users className="h-8 w-8 text-muted-foreground animate-pulse" />
            <Skeleton className="h-8 w-64" />
          </div>
          <Skeleton className="h-4 w-96 mx-auto" />
        </CardHeader>
        
        <CardContent>
          {/* Tabs Skeleton */}
          <div className="flex gap-2 mb-6 p-1 bg-muted rounded-lg">
            <Skeleton className="h-10 flex-1" />
            <Skeleton className="h-10 flex-1" />
            <Skeleton className="h-10 flex-1" />
          </div>

          {/* Content Area */}
          <div className="space-y-6">
            {/* Selector 1 */}
            <div className="space-y-2">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-11 w-full" />
            </div>

            {/* Selector 2 */}
            <div className="space-y-2">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-11 w-full" />
            </div>

            {/* Button */}
            <div className="flex justify-center pt-4">
              <Skeleton className="h-11 w-48" />
            </div>
          </div>

          {/* Pagination Skeleton */}
          <div className="flex items-center justify-between pt-6 mt-6 border-t border-border">
            <Skeleton className="h-9 w-32" />
            <div className="flex items-center gap-2">
              <Skeleton className="h-9 w-9 rounded-md" />
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-9 w-9 rounded-md" />
            </div>
            <Skeleton className="h-9 w-32" />
          </div>
        </CardContent>
      </Card>
    </div>
  </div>
);
